import { IAdminTenantHttpParams } from '@core/interfaces/api.interface';
import {
	AllowedDetailsTabEnum,
	ProductEnum
}                                 from '@core/interfaces/common.interfaces';
import {
	RouteBaseDefinition,
	RouteBasePath
}                                 from '@core/interfaces/route.interface';


export enum TenantRoutesEnum {
	ListPage = '',
	DetailPage = ':tenantId',
	FormPageCreate = 'create',
	FormPageCreateSubaccount = ':parentTenantId/create',
	FormPageUpdate = ':tenantId/update',
	DetailPageTab = ':tenantId/:tab',
	UsagePage = ':tenantId/usage/:product/:usagePeriod'
}

export enum AllowedDetailPageChildRoutes {
	SubTenants = ':tenantId/subtenants'
}

export interface TenantListPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.ListPage;
	queryParams?: IAdminTenantHttpParams;
}

export interface TenantDetailPageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.DetailPage;
	params: { tenantId: string };
}

export interface TenantFormPageCreateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.FormPageCreate;
}

export interface TenantFormPageCreateSubaccountRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.FormPageCreateSubaccount;
	params: { parentTenantId: string };
}

export interface TenantFormPageUpdateRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.FormPageUpdate;
	params: { tenantId: string };
}

export interface TenantDetailPageTabRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.DetailPageTab;
	params: {
		tenantId: string,
		tab: AllowedDetailsTabEnum
	};
	replaceLastStoredRouteWithNew: boolean;
}

export interface TenantUsagePageRoute extends RouteBaseDefinition {
	basePath: RouteBasePath.Tenant;
	path: TenantRoutesEnum.UsagePage;
	params: {
		product: ProductEnum,
		tenantId: string,
		usagePeriod: string
	};
}
